import PropTypes from 'prop-types';
import { Dialog, Stack, Typography } from '@mui/material';
import { CreatePasswordForm } from './components/form/CreatePasswordForm';

CreatePasswordModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default function CreatePasswordModal({ open, handleClose }) {
  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
      <Stack p={3} gap={2}>
        <Typography variant="h6">Cadastre sua senha</Typography>
        <CreatePasswordForm handleClose={handleClose} />
      </Stack>
    </Dialog>
  );
}
